import { IncomingMessage } from 'http';

import { getEnumValues } from '@klokhuis/utilities/Enum';

export enum AppCookieName {
  LEGACY_AUTH = 'logonUser',
  ANONYMOUS_ID = 'klohkhuis_anonymous_id',
  ACCESS_TOKEN = 'accessToken',
  REFRESH_TOKEN = 'refreshToken',
}

export function readAppCookies(
  req: IncomingMessage,
): Record<string, string | null> {
  const cookiesList = getEnumValues(AppCookieName);
  const cookies: Record<string, string | null> = {};
  for (const cookieName of cookiesList) {
    cookies[cookieName] = req.cookies[cookieName] || null;
  }
  return cookies;
}
